import type { TechSupportMetrics } from "@expert/sales-tools";

import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { useQuery } from "@tanstack/react-query";

import { env } from "@/config";

import { getBusinessToday } from "./businessDay";
import { getYesterdayPerformanceMetrics } from "./getYesterdayPerformanceMetrics";
import { getMockPerformanceMetrics } from "./mocks";

export interface YesterdayPerformanceMetrics {
    metrics: TechSupportMetrics | null;
    isLoading: boolean;
    isError: boolean;
}

export function useYesterdayPerformanceMetrics(): YesterdayPerformanceMetrics {
    const {
        features: { isMorningPaperEnabled },
    } = useFeatures<WorkspaceFeatures>();

    const { data, isLoading, isError, status } = useQuery({
        queryKey: ["morningPaper", "performanceMetrics", getBusinessToday()],
        queryFn: getYesterdayPerformanceMetrics,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: 0,
        enabled: isMorningPaperEnabled,
    });

    const mock = !env.isProdMode && status === "success" ? getMockPerformanceMetrics() : null;

    const metrics: TechSupportMetrics | null = mock
        ? {
              ...data,
              entireRepPerformance: data?.entireRepPerformance ?? mock.entireRepPerformance,
              fiveStarRating: data?.fiveStarRating ?? mock.fiveStarRating,
              callResolutionTime: data?.callResolutionTime ?? mock.callResolutionTime,
              netEnrolls: data?.netEnrolls ?? mock.netEnrolls,
          }
        : (data ?? null);

    return {
        metrics,
        isLoading,
        isError,
    };
}
